import { Mutation, VuexModule, Module } from "vuex-module-decorators";
import { store } from "@/store/Store";
import log from "loglevel";

export type SolanProjectInfo = {
  name: string;
};

// プロジェクト編集中に、プロジェクトヘッダからプロジェクト編集画面への値の伝播に用いるストア。
@Module({ dynamic: true, store, name: "solanProjectInfoOnEditStore", namespaced: true })
export class SolanProjectInfoOnEditStore extends VuexModule {
  // この値がnullでないとき、編集中である。
  info: SolanProjectInfo | null = null;

  @Mutation
  public startEditing(initialInfo: SolanProjectInfo) {
    this.info = {
      name: initialInfo.name,
    };
    log.debug(`startEditing: ${JSON.stringify(this.info)}`);
  }

  @Mutation
  public finishEditing() {
    this.info = null;
  }

  @Mutation
  public updateName(value: string) {
    const info = this.info;
    if (info === null) return;
    info.name = value;
  }
}
